import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './Scrollable.module.scss'

const Scrollable = props => {
  let list
  const [isScrolling, setScrollingState] = useState(false)

  const handleScroll = () => {
    if (
      !list ||
      list.scrollTop < 10 && !isScrolling ||
      list.scrollTop > 10 && isScrolling
    ) return

    const nextScrollValue = list.scrollTop > 10
    setScrollingState(nextScrollValue)
  }

  return (
    <div
      ref={ref => list = ref}
      onScroll={handleScroll}
      className={classNames(
        styles.scrollable,
        isScrolling && styles.scrolling,
        props?.className
      )}
      styles={props?.styles}
    >
      {props?.children}
    </div>
  )
}

Scrollable.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  styles: PropTypes.any
}

export default Scrollable
